import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

// Same-origin deployments get relative media URLs so <link rel=preload> in the HTML matches the <img> src.
const sameOrigin = typeof window !== "undefined" && BACKEND_URL && new URL(BACKEND_URL).host === window.location.host;
export const mediaUrl = (u) => (u && u.startsWith("/api/") ? (sameOrigin ? u : `${BACKEND_URL}${u}`) : u || "");
// Responsive attrs for WebP uploads: every upload ships with an 800px "-md" variant.
export const imgSet = (u, sizes = "100vw") => {
  const src = mediaUrl(u);
  if (!u || !u.endsWith(".webp") || u.endsWith("-md.webp") || u.endsWith("-thumb.webp")) return { src };
  return { src, srcSet: `${mediaUrl(u.slice(0, -5) + "-md.webp")} 800w, ${src} 1264w`, sizes };
};

export const COMPANY = "M & S Green Estate Pvt. Ltd.";
export const TAGLINE = "जहां हर घर में बसे कान्हा.";
export const ADDRESS = "C-277, Ground Floor, Sector-63, Noida, Gautam Buddha Nagar, Uttar Pradesh - 201301";
export const WEBSITE = "www.msgreenestate.com";

export const normaliseMobile = (raw) => {
  let d = (raw || "").replace(/\D/g, "");
  if (d.length === 12 && d.startsWith("91")) d = d.slice(2);
  else if (d.length === 11 && d.startsWith("0")) d = d.slice(1);
  return d;
};
export const isValidMobile = (raw) => /^[6-9]\d{9}$/.test(normaliseMobile(raw));
export const isValidEmail = (e) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e);

export const formatError = (detail) => {
  if (!detail) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
};

export const whatsappLink = (settings) =>
  settings?.whatsapp_number
    ? `https://wa.me/${settings.whatsapp_number.replace(/\D/g, "")}?text=${encodeURIComponent(settings.whatsapp_message || "")}`
    : "";
